import { FormControl } from '@mui/material'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'
import makeStyles from '@mui/styles/makeStyles'
import { SORT_CLICKS, SORT_DATE, SORT_RELEVANCE, SORT_TITLE } from 'lib/constants'
import { buildHref } from 'lib/utils'
import { useRouter } from 'next/router'

const useStyles = makeStyles((theme) => ({
  sort: {
    display: 'flex',
    flexDirection: 'row'
  },
  label: {
    paddingTop: '8px',
    marginRight: '10px',
    position: 'relative',
    color: theme.palette.text.secondary
  },
  select: {
    width: '120px',
    marginTop: 0
  }
}))

export default function Sort ({ query }) {
  const classes = useStyles()
  const router = useRouter()

  const handleChange = (event) => {
    const val = event.target.value
    // start with first page
    delete query.page
    const href = buildHref('/search', query, { sort: val === SORT_RELEVANCE ? null : val, page: null })
    router.push(href)
  }

  return (
    <FormControl className={classes.sort} variant='standard'>
      <div className={classes.label}>sortiert&nbsp;nach:&nbsp;</div>
      <Select
        id='sort'
        value={value(query)}
        onChange={handleChange}
        className={classes.select}
      >
        <MenuItem value={SORT_RELEVANCE}>Relevanz</MenuItem>
        <MenuItem value={SORT_DATE}>Sendetermin</MenuItem>
        <MenuItem value={SORT_CLICKS}>Aufrufe</MenuItem>
        <MenuItem value={SORT_TITLE}>Titel A bis Z</MenuItem>
      </Select>
    </FormControl>
  )
}

function value (query) {
  const options = [SORT_DATE, SORT_CLICKS, SORT_TITLE]

  // catch unknown values
  if (options.some(x => x === query.sort)) {
    return query.sort
  } else {
    return SORT_RELEVANCE
  }
}
